export const digitsOnly = (value: string | null | undefined): string => (value ?? '').replace(/\D/g, '')

export const cleanPhone = (value: string | null | undefined): string | null => {
    if (!value) return null

    const trimmed = value.trim()
    const digits = digitsOnly(trimmed)

    if (digits.length < 7) return null

    return trimmed.startsWith('+') ? `+${digits}` : digits
}

export const isValidPhone = (value: string | null | undefined): boolean => {
    const digits = digitsOnly(value)
    return digits.length >= 10 && digits.length <= 15
}

export const samePhone = (a: string | null | undefined, b: string | null | undefined): boolean => {
    const first = digitsOnly(a)
    const second = digitsOnly(b)

    if (first.length < 7 || second.length < 7) return false

    return first.slice(-10) === second.slice(-10)
}

export const toWhatsAppNumber = (value: string | null | undefined, countryCode: string): string | null => {
    if (!value) return null

    const trimmed = value.trim()
    const code = digitsOnly(countryCode)
    let digits = digitsOnly(trimmed)

    if (!digits) return null

    if (!trimmed.startsWith('+')) {
        if (digits.startsWith('00')) digits = digits.slice(2)
        else if (digits.length === 11 && digits.startsWith('0')) digits = `${code}${digits.slice(1)}`
        else if (digits.length <= 10) digits = `${code}${digits}`
    }

    return digits.length >= 8 && digits.length <= 15 ? digits : null
}

export const formatPhone = (value: string | null | undefined): string => {
    if (!value) return ''

    const trimmed = value.trim()
    const digits = digitsOnly(trimmed)

    if (!trimmed.startsWith('+') && digits.length === 10) return `${digits.slice(0, 5)} ${digits.slice(5)}`
    if (digits.length === 12 && digits.startsWith('91')) return `+91 ${digits.slice(2, 7)} ${digits.slice(7)}`

    return trimmed.startsWith('+') ? `+${digits}` : digits
}

export const telHref = (value: string | null | undefined): string | null => {
    const digits = digitsOnly(value)

    if (digits.length < 7) return null

    return value?.trim().startsWith('+') ? `tel:+${digits}` : `tel:${digits}`
}
